module.exports = __webpack_public_path__ + "img/brush.1bb0e822.svg";